import React from 'react';
import Error from './Error.js';

const AppError = () => {
  return (<Error title="Wystąpił błąd"/>);
}

export default AppError;
